import { render, staticRenderFns } from "./IdReceConf.vue?vue&type=template&id=32cfc9bf&scoped=true&"
import script from "./IdReceConf.vue?vue&type=script&lang=js&"
export * from "./IdReceConf.vue?vue&type=script&lang=js&"
import style0 from "./IdReceConf.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IdReceConf.vue?vue&type=style&index=1&id=32cfc9bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cfc9bf",
  null
  
)

export default component.exports